export default {"src":"/_next/static/image/public/landing/balls.87834e4a62c532e2680de0f92879764d.svg","height":430,"width":1538};